export default {
  methods: {
    getLanguageCodeForNumbers () {
      switch (this.$i18n.locale) {
        case 'en':
          return 'en'
        case 'sr':
        case 'ba':
          return 'sr'
        default:
          return 'sr'
      }
    },
    getLanguageNameByCode (lang) {
      let language = lang || this.$i18n.locale
      switch (language) {
        case 'en':
          return this.$t('language_english')
        case 'sr':
          return this.$t('language_serbian')
        case 'ba':
          return this.$t('language_serbian_ba')
        default:
          return this.$t('language_serbian')
      }
    },
    getLanguageClassByCode (code) {
      switch (code) {
        case 'en':
          return 'flag-icon-gb-eng'
        case 'sr':
        case 'ba':
          return 'flag-icon-rs'
        default:
          return 'flag-icon-rs'
      }
    }
  }
}
